import { MenuItem } from "@/app/ui/navigation/types";
import { EnumFeatureFlag } from "@/app/services/generated/enums/enumFeatureFlag.generated";
import { RouteBuilder } from "@/app/ui/navigation/routeBuilder";
import { keys } from "@/plugins/i18n";

const builder = new RouteBuilder("Gallery_");

export const galleryRoutes = {
  typography: builder.route({
    url: "/gallery/typography",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Typography.vue"
      ),
  }),
  controls: builder.route({
    url: "/gallery/controls",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Controls.vue"
      ),
  }),
  singleControls: builder.route({
    url: "/gallery/singleControls",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/SingleControls.vue"
      ),
  }),
  production: builder.route({
    url: "/gallery/production",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Production.vue"
      ),
  }),
  grids: builder.route({
    url: "/gallery/grids",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Grids.vue"
      ),
  }),
  largeGrid: builder.route({
    url: "/gallery/largegrid",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/LargeGrid.vue"
      ),
  }),
  geocode: builder.route({
    url: "/gallery/geocode",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Geocode.vue"
      ),
  }),
  pageLayout: builder.route({
    url: "/gallery/page_layout",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/PageLayout.vue"
      ),
  }),
  validation: builder.route({
    url: "/gallery/validation",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Validation.vue"
      ),
  }),
  tableau: builder.route({
    url: "/gallery/tableau/reporting/RevenueMap",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/reporting/embeddedtableau/EmbeddedTableauReport.vue"
      ),
    componentProps: (route) => ({
      workbook: "ReportingProduction",
      view: "RevenueMap",
    }),
  }),
  timeline: builder.route({
    url: "/gallery/timeline",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Timeline.vue"
      ),
  }),
  pipeline: builder.route({
    url: "/gallery/pipeline",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/LeadsPipelineGallery.vue"
      ),
  }),
  errorTests: builder.route({
    url: "/gallery/error_testing",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/ErrorTests.vue"
      ),
  }),
  buttonBarPlayground: builder.route({
    url: "/gallery/buttonbar",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/ButtonBarPlayground.vue"
      ),
  }),
  logging: builder.route({
    url: "/gallery/logging",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/Logging.vue"
      ),
  }),
  forms: builder.route({
    url: "/gallery/forms",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "gallery" */ "@/components/pages/gallery/forms/GalleryFormParent.vue"
      ),
  }),
};

export const buildGalleryMenuItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    translationKey: keys.navigation_gallery_group.value,
    icon: "Web",
    requiredFeatureFlag: EnumFeatureFlag.showGallery,
    subMenus: [
      MenuItem.forRoute("Typography", galleryRoutes.typography),
      MenuItem.forRoute("Controls", galleryRoutes.controls),
      MenuItem.forRoute("Single Controls", galleryRoutes.singleControls),
      MenuItem.forRoute("Production", galleryRoutes.production),
      MenuItem.forRoute("Grids", galleryRoutes.grids),
      MenuItem.forRoute("Large Grid", galleryRoutes.largeGrid),
      MenuItem.forRoute("Geocode", galleryRoutes.geocode),
      MenuItem.forRoute("Page Layout", galleryRoutes.pageLayout),
      MenuItem.forRoute("Validation", galleryRoutes.validation),
      MenuItem.forRoute("Tableau Embedded", galleryRoutes.tableau),
      MenuItem.forRoute("Timeline", galleryRoutes.timeline),
      MenuItem.forRoute("Pipeline", galleryRoutes.pipeline),
      MenuItem.forRoute("Error Tests", galleryRoutes.errorTests),
      MenuItem.forRoute("Button Bar", galleryRoutes.buttonBarPlayground),
      MenuItem.forRoute("Logging", galleryRoutes.logging),
      MenuItem.forRoute("Forms", galleryRoutes.forms),
    ],
  }),
];

//export const buildGalleryMenuItems: () => MenuItem[] = () => [];

/*export const galleryMenu = {
  root: "navigation_gallery_group",
  typography: "typography",
  controls: "controls",
  singleControls: "singleControls",
  production: "production_gallery",
  grids: "grids",
  viewGrids: (): Location => ({
    name: galleryMenu.grids,
  }),
  largeGrid: "large_grid",
  geocode: "geocode",
  maps: "maps",
  pageLayout: "page_layout",
  async: "async",
  validation: "validation",
  timeline: "timeline",
  pipeline: "pipeline",
  dataProviders: "data_providers",
  tableauEmbedded: "tableau_embedded",
  errorTests: "error_tests",
  buttonBarPlayground: "buttonBarPlayground",
  logging: "logging",
  forms: "forms",
};
*/
